import { FileUploader } from '@/common/components/FileUploader'
import { DocumentData } from '@/common/types/document'
import { ContactData } from '@/features/publicCompanyLeadsFunnel/types/publicCompanyLead'
import { Dispatch, SetStateAction } from 'react'

interface ContactDocumentProps {
  contactDocument?: ContactData['documents'][0]
  document: DocumentData
  fileName?: string
  currentFileUrl?: string
  setFiles: Dispatch<SetStateAction<{ id: string; file: Blob; fileName: string }[]>>
  disabled?: boolean
  dataTestid?: string
  onChange?: (file: Blob) => void
}

export const ContactDocument = ({
  contactDocument,
  document,
  fileName,
  currentFileUrl,
  setFiles,
  disabled,
  dataTestid,
  onChange,
}: ContactDocumentProps) => {
  return (
    <FileUploader
      className="w-full"
      name={contactDocument?.id}
      disabled={disabled}
      accept="application/pdf, image/png, image/jpg, image/jpeg"
      title={`Anexe seu documento de ${document.display_name}`}
      fileName={fileName}
      currentFileUrl={currentFileUrl}
      handleChange={(file) => {
        setFiles((prev) => {
          if (!contactDocument?.id) {
            return prev
          }

          onChange?.(file);

          const fileIndex = prev.findIndex((file) => file.id === contactDocument?.id)

          if (fileIndex === -1) {
            return [...prev, { id: contactDocument?.id, file, fileName: file.name }]
          }

          prev[fileIndex] = { id: contactDocument?.id, file, fileName: file.name }

          return [...prev]
        })
      }}
      dataTestid={dataTestid}
    />
  )
}
